import { os } from '@utils/device-utils';
import AcSwipe from 'ac-components/ac-swiper';
import classnames from 'classnames';
import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import React, { FC } from 'react';
import styles from './styles.scss';



const WorksSection: FC = () => {
	const { width } = useResizeObserver();
	const { transData, list } = useTranslation('oneOnOne.works')

	const ListRenderTitle = list.map((item, index) => {
		return (
			<div
				key={index}
				className={styles['title-item']}
			>
				<div className={styles['img-wrap']}>
					<img loading='lazy' src={item.icon} alt="" />
				</div>
				<p>{item.context}</p>
			</div>
		)
	})

	return (
		<section className={styles['ac-works']}>
			<div className={styles['ac-works-container']}>
				<div dangerouslySetInnerHTML={{ __html: transData.title }} />
				<div className={styles['ac-works-content']}>
					<img src="https://web-data.zmlearn.com/image/nWrMHZB7GoSgCzEcP4AqeU/img_p5_pic1%402x.png" alt="" loading='lazy' />
					{(width >= 768 && width < 1192) && <>
						<img src="https://web-data.zmlearn.com/image/4gQP81m5AHMa6Dppr15LbF/img_P5%402x.png" alt="" loading='lazy' />
						<img src="https://web-data.zmlearn.com/image/nTonBEesrwYrDMoKLvZueZ/img_P5%402x%20(1).png" alt="" loading='lazy' />
					</>}
					<div className={classnames(styles['ac-works-title'], 'ac-works-title')}
					>{ListRenderTitle}</div>
				</div>
			</div>
		</section >
	);
}

export default WorksSection
